import { render } from "./DmClientProductDocuments.vue?vue&type=template&id=583eb882&ts=true"
import script from "./DmClientProductDocuments.vue?vue&type=script&lang=ts"
export * from "./DmClientProductDocuments.vue?vue&type=script&lang=ts"

import "./DmClientProductDocuments.vue?vue&type=style&index=0&id=583eb882&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__